export default __webpack_public_path__ + "static/media/silka-semibold-webfont.06edbc6c.woff";